/**
 * To detect javascript is enabled
 */
const htmlEl = document.querySelector('html.no-js')

if ( htmlEl && htmlEl.classList.contains('no-js') ) {
    htmlEl.classList.replace('no-js', 'js')
}
